/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserResponseAdminUserDto } from '../../models/user-response-admin-user-dto';

export interface AdminAuthControllerFindByTokenV1$Params {
  refresh: string;
}

export function adminAuthControllerFindByTokenV1(http: HttpClient, rootUrl: string, params: AdminAuthControllerFindByTokenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<UserResponseAdminUserDto>> {
  const rb = new RequestBuilder(rootUrl, adminAuthControllerFindByTokenV1.PATH, 'get');
  if (params) {
    rb.path('refresh', params.refresh, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserResponseAdminUserDto>;
    })
  );
}

adminAuthControllerFindByTokenV1.PATH = '/v1/admin/auth/user/{refresh}';
